import React from 'react';
import { Helmet } from 'react-helmet';

const FontOptimizer = () => {
  return (
    <Helmet>
      {/* Preconnect to Google Fonts */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      
      {/* Load fonts with display swap */}
      <link
        href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />
      
      {/* Add font-display: swap to any custom fonts */}
      <style>
        {`
          @font-face {
            font-family: 'CustomFont';
            src: url('/fonts/custom.woff2') format('woff2');
            font-display: swap;
          }
        `}
      </style>
    </Helmet>
  );
};

export default FontOptimizer; 